module.exports = __webpack_public_path__ + "static/media/vcathd.6fc4ec4c.png";